import { IRootState } from '../../../store'
import { IPatientInformationState } from '../store/patientInformation.types'

export const getPatientInformationState = (state: IRootState): IPatientInformationState => state.patientInformation
